import { render, staticRenderFns } from "./RecentReviews.vue?vue&type=template&id=1e4e6628&scoped=true&lang=pug&"
import script from "./RecentReviews.vue?vue&type=script&lang=ts&"
export * from "./RecentReviews.vue?vue&type=script&lang=ts&"
import style0 from "./RecentReviews.vue?vue&type=style&index=0&id=1e4e6628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e6628",
  null
  
)

export default component.exports